<template>
  <el-button type="primary" @click="toggleExpand" class="w-full md:w-1/2 mt-4">
    <Icon
      :icon="isExpanded ? 'fa-solid:chevron-up' : 'fa-solid:chevron-down'"
      class="mr-4"
    />
    Embed Settings
  </el-button>
  <div
    ref="contentRef"
    :class="{ expand: isExpanded, collapse: !isExpanded }"
    class="overflow-hidden transition-max-height duration-500 ease-in-out bg-gray-900 rounded-br-lg rounded-bl-lg w-full md:w-1/2"
  >
    <div class="my-8 w-full md:w-3/4 mx-auto">
      <div>
        To let reviewers go through the review process on your website, as
        opposed to on HeroGrow, you can embed the review widget on your website.
        <br />
        <br />
        Use the <b>Copy Code</b> button below and paste it into your website to
        embed the review widget.
      </div>
      <textarea
        class="mt-4"
        id="embedCode"
        readonly
        :value="iframeCode"
        rows="10"
        cols="50"
      ></textarea>

      <div class="w-full">
        <el-button @click="copyCode" type="primary">Copy Code</el-button>
        <span v-if="copied" class="mx-4 text-green-500">Code copied!</span>
      </div>
      <div class="mt-4">
        After you've embedded the widget code, fill in the
        <b>Remote Review Page URL</b> field below with the URL of the page where
        the widget code was inserted and enable the <br />
        <b>Use Remote Page for Reviews</b> option below.
      </div>
      <div class="mt-4">
        Remote Review Page URL:
        <el-input
          v-model="userStore.settings.remoteReviewPageUrl"
          placeholder="https://www.your-site.com/the-review-page"
        ></el-input>
      </div>
      <div class="flex justify-around bg-gray-800 pb-4">
        <div class="mt-4">Use Remote Page for Reviews:</div>
        <el-switch
          :disabled="!userStore.settings.remoteReviewPageUrl"
          v-model="userStore.settings.useRemoteReviewPage"
          class="mt-4"
        ></el-switch>
      </div>
      <div class="my-4 text-center">
        Remember to try a test review first to make sure everything is working!
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { copyToClipboard } from "@/utils";
import { Icon } from "@iconify/vue";
import { useUser } from "@/stores";
import useExpandable from "@/composables/useExpandable";

const { isExpanded, contentRef, toggleExpand } = useExpandable();

const userStore = useUser();

const copied = ref(false);

const iframeCode = ref(
  [
    "<iframe",
    '  id="reviewFrame"',
    '  width="600"',
    '  height="400"',
    '  frameborder="0"',
    '  allow="encrypted-media"',
    '  title="Reviewer View">',
    "</iframe>",
    "",
    '<script type="text/javascript">',
    "  function getReviewId() {",
    "    const url = new URL(window.location.href);",
    "    const reviewId = url.searchParams.get('reviewId');",
    "    return reviewId;",
    "  }",
    "",
    "  const reviewFrame = document.getElementById('reviewFrame');",
    '  reviewFrame.src = "https://herogrow.net/r/" + getReviewId();',
    "<" + "/script>",
  ].join("\n")
);

function copyCode() {
  const textarea = document.getElementById("embedCode");
  textarea.select();
  copyToClipboard(textarea.value);
  copied.value = true;
}
</script>

<style scoped>
textarea {
  width: 100%;
  margin-bottom: 10px;
}
</style>
